import { useRef, useEffect, useContext } from 'react';
import { lineChartColors } from '../../../theme/colors';
import { OverviewContext } from '../../overview-provider';

export const useChartUtilities = () => {
  const { currency } = useContext(OverviewContext);
  const colors = useRef<string[]>([...lineChartColors]);
  const volSeriesColorMap = useRef(new Map<string, string>());
  const flySeriesColorMap = useRef(new Map<string, string>());
  const futureSeriesColorMap = useRef(new Map<string, string>());

  const resetColors = () => {
    colors.current = [...lineChartColors];
    volSeriesColorMap.current.clear();
    flySeriesColorMap.current.clear();
    futureSeriesColorMap.current.clear();
  };

  useEffect(resetColors, [currency]);

  return {
    chartColorsMap: {
      colors,
      volSeriesColorMap,
      flySeriesColorMap,
      futureSeriesColorMap,
      resetColors,
    },
  };
};
